import { render } from "./carpet-lookup.vue?vue&type=template&id=226af26c"
import script from "./carpet-lookup.vue?vue&type=script&setup=true&lang=js"
export * from "./carpet-lookup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/recycle/carpet-lookup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "226af26c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('226af26c', __exports__)) {
    api.reload('226af26c', __exports__)
  }
  
  module.hot.accept("./carpet-lookup.vue?vue&type=template&id=226af26c", () => {
    api.rerender('226af26c', render)
  })

}


export default __exports__